import * as z from "zod"

export const ShipmentSubscriberModel = z.object({
  id: z.number().int(),
  created_at: z.date(),
  updated_at: z.date(),
  unsubscribed_at: z.date().nullish(),
  contact_id: z.number().int(),
  request_id: z.number().int(),
})
